export default {
  namespaced: true,
  state:{
    franchiseData: {},
    allowedCategories: {}
  },
  getters:{

  },
  mutations:{
    updateApplication(state, payload){
      state.franchiseData = { ...state.franchiseData, ...payload }
    }

  },
  actions:{

  }
}


// WEBPACK FOOTER //
// ./src/store/modules/applicationModule.js